import { api } from 'helpers'
import { AxiosResponse } from 'axios'

export async function getModalityFinalProductList(): Promise<AxiosResponse> {
  try {
    const response = await api.get('/api/projects/modalities_and_final_products')
    return response
  } catch (error: any) {
    return error
  }
}
